import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from "./Step1";
import Instructions from "./Instructions";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const RescheduleService = (props) => {
  document.title = `${i18n.t("RescheduleServices")} - ${orgId}`;

  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
    }
  }, [dispatch, data, loading]);

  const switchStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            setStep={setStep}
            step={step}
            token={token}
            infoUser={infoUser}
            setErrorAlert={setErrorAlert}
            setErrorAlertMessage={setErrorAlertMessage}
          />
        );
      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Services")}
            link={"/services/request"}
            breadcrumbItem={i18n.t("Reschedule")}
          />
          <Row>
            <Card>
              <CardBody>
                <Instructions step={step}></Instructions>
              </CardBody>
            </Card>
          </Row>
          <Col xxl={12} md={12} xs={12} className="">
            <AlertError
              showAlertError={errorAlert}
              setShowAlertError={setErrorAlert}
              textHeader={i18n.t("Error")}
              textBody={errorAlertMessage}
            />
          </Col>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RescheduleService;
